import { GET_SIDEBAR_ACTIONS, SET_SIDEBAR_ACTIONS, SIDEBAR_EXPANDED_KEYS } from "./types";
export const getSidebarActions = (data) => ({
    type: GET_SIDEBAR_ACTIONS,
    payload: data,
});
export const setSidebarActions = (data) => ({
    type: SET_SIDEBAR_ACTIONS,
    payload: data,
});
export const sidebarExpandedKeys = (data) => ({
    type: SIDEBAR_EXPANDED_KEYS,
    payload: data,
});
